import { useEffect, useState } from "react";
import { EquipamientoFiltro } from "../../../../types/Equipamiento";
import { useEquipamiento } from "../../../../hooks/useEquipamiento";
import FormSelectBox from "../../../../components/Form/FormSelectBox";
import FormInput from "../../../../components/Form/FormInput";

const estados = [
    { 'id': 'true', 'valor': 'ACTIVO' },
    { 'id': 'false', 'valor': 'INACTIVO' }
];

export const BuscarEquipamiento = () => {
    const { equipamientoFiltroInitial, buscarEquipamientos, filtro, handleFiltroEquipamiento, paginacion } = useEquipamiento();
    const [filtroEquipamiento, setFiltroEquipamiento] = useState<EquipamientoFiltro>(filtro);

    useEffect(() => {
        buscarEquipamientos(filtro, 0, paginacion.size);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        e.preventDefault();
        setFiltroEquipamiento({
            ...filtroEquipamiento,
            [e.target.name]: e.target.value,
        });
    };

    const handleSubmit = (e: React.FormEvent | React.MouseEvent) => {
        e.preventDefault();
        handleFiltroEquipamiento(filtroEquipamiento);
        buscarEquipamientos(filtroEquipamiento, 0, paginacion.size);
    }

    // Limpiar solo reinicia el formulario para una nueva búsqueda; la grilla sigue mostrando la última aplicada.
    const handleClean = () => {
        setFiltroEquipamiento(equipamientoFiltroInitial);
    };

    return (
        <div className="card">
            <form id="dto" className="form-horizontal" onSubmit={handleSubmit}>
                <div className="card-body">
                    <h4 className="m-t-0 header-title">
                        <i className="fa fa-search margin-right-7" aria-hidden="true" style={{ marginRight: "5px" }}></i>
                        Buscar
                    </h4>
                    <hr />

                    <div className="row mt-2">
                        <FormInput
                            id={'nombre'}
                            label={'Nombre'}
                            name={'nombre'}
                            placeholder={'Nombre'}
                            onChange={handleChange}
                            value={filtroEquipamiento.nombre}
                        />

                        <FormSelectBox
                            title={'Estado'}
                            label={'estado'}
                            id={'activo'}
                            name={'activo'}
                            onChange={handleChange}
                            optionId={'id'}
                            optionLabel={'valor'}
                            value={filtroEquipamiento.activo}
                            options={estados}
                            seleccionarText="TODOS"
                        />
                    </div>

                    <hr />
                    <div className="row">
                        <div className="col-md-12 text-center">
                            <button className="btn btn-secondary btn-rounded waves-effect waves-light mr-1" type="button" id="limpiarFiltro" onClick={handleClean}>
                                <i className="fa fa-refresh mr-1" aria-hidden="true"></i>
                                Limpiar
                            </button>
                            <button className="btn btn-success btn-rounded waves-effect waves-light " type="submit">
                                <i className="fa fa-search mr-1"></i>
                                Buscar
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    )
}
